import React from "react";

import "./PortalName.scss";

export const PortalName = ({ name }) => (
  <div className="portal-name">{name}</div>
);
